export default __webpack_public_path__ + "static/media/louvre.9034c865.svg";